module.exports = __webpack_public_path__ + "static/1_1_defineai_CS-2186ee06a645f5b5d580ca07ca951502.svg";